'use client';

import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, ModalStickyBottomWrapper, TextList, TextListGroup } from '@repo/ui';
import React, { useEffect } from 'react';

export const SenaIntroduceModal = NiceModal.create(() => {
  const modal = useModal();
  const { sendViewEvent } = useUserEventLogger();

  useEffect(() => {
    if (modal.visible) {
      sendViewEvent('introduce-sena_modal', {}, { isAllowRetry: true });
    }
  }, [modal.visible, sendViewEvent]);

  return (
    <Drawer open={modal.visible}>
      <DrawerContent disableOutsideClick>
        <DrawerHeader className={'flex flex-col gap-normal-small'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_megaphone_md.svg`} className={'w-12 h-12'} alt="megaphone icon" />
          <div className="heading-small-bold">비즈넵 세나는 이런 서비스예요</div>
        </DrawerHeader>
        <DrawerBody>
          <div className="body-medium-regular text-neutral-foreground-low">
            <div className="mb-normal-medium">세나는 12만 건의 판례와, 26만 건의 국세청 질의회신 데이터를 기반한 AI 세무·법률·노무 무료 상담 서비스입니다.</div>
            <div className="mb-normal-medium">
              <div className="body-medium-bold text-neutral-foreground-main mt-0 mb-tiny-medium">세나의 특징</div>
              <ul className="space-y-tiny-small body-small-regular list-disc pl-6 mt-0">
                <li>전문 분야 특화 AI로 기존 AI보다(GPT 등) 빠르고 정확한 답변</li>
                <li>실제 전문가가 실시간 검증한 답변</li>
                <li>24시간 무료 이용하는 기본 상담 서비스</li>
                <li>법령이 변경될 때마다 실시간으로 반영되어 항상 최신화된 답변</li>
              </ul>
            </div>
            <div>
              복잡한 세금 환급, 법인세, 부가가치세, 종합소득세 관련 상담과 어려운 상속·증여나 부동산 거래와 관련된 법률 검토를 질문을 통해 답변받아보시고, 세무
              계산기와 급여명세서 작성 지원 등 부가 서비스까지 세나에서 만나보세요.
            </div>
          </div>
        </DrawerBody>
        <DrawerFooter>
          <ModalStickyBottomWrapper>
            <BoxButton size={'large'} variant={'filled-primary'} onClick={() => modal.hide()} className="w-full">
              확인
            </BoxButton>
          </ModalStickyBottomWrapper>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});

export const SenaInformationUseModal = NiceModal.create(() => {
  const modal = useModal();
  const { sendViewEvent } = useUserEventLogger();

  useEffect(() => {
    if (modal.visible) {
      sendViewEvent('information-use_modal', {}, { isAllowRetry: true });
    }
  }, [modal.visible, sendViewEvent]);

  return (
    <Drawer open={modal.visible}>
      <DrawerContent disableOutsideClick>
        <DrawerHeader className={'flex flex-col gap-normal-small'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_megaphone_md.svg`} className={'w-12 h-12'} alt="megaphone icon" />
          <div className="heading-small-bold">AI 세무상담 이용안내</div>
        </DrawerHeader>
        <DrawerBody>
          <div className="body-medium-regular text-neutral-foreground-low">
            <div className="mb-normal-medium">
              본 서비스는 (주)지엔터프라이즈의
              <br />
              AI 무료 상담 서비스인 bzs;를 통해 제공돼요.
            </div>
            <div className="mb-normal-medium">
              <ul className="space-y-tiny-small body-small-regular list-disc pl-6 mt-0">
                <li>AI 답변을 바탕으로 진행한 고객님의 계약사항 및 세무처리 등에는 별도 책임을 지지 않아요. AI 답변은 절대적인 지표가 아님을 기억해주세요.</li>
                <li>중요한 법률적 결정 전에는 전문가와 별도 상의하시는 것을 권장드려요.</li>
                <li>세나 서비스는 현재 별도 회원가입 없이 바로 이용이 가능해요.</li>
                <li>AI 세무상담 화면에서 이탈하신 후 재진입 시 질문하신 내역을 확인하실 수 없으니 서비스 이용에 유의해주세요.</li>
              </ul>
            </div>
          </div>
        </DrawerBody>
        <DrawerFooter>
          <ModalStickyBottomWrapper>
            <BoxButton size={'large'} variant={'filled-primary'} onClick={() => modal.hide()} className="w-full">
              확인
            </BoxButton>
          </ModalStickyBottomWrapper>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});

export const JoinsInformationUseModal = NiceModal.create(() => {
  const modal = useModal();
  const { sendViewEvent } = useUserEventLogger();

  const groupSectionStyle = 'flex flex-col gap-tiny-medium';
  const textGroupTitleStyle = 'body-medium-bold text-neutral-foreground-main';
  const textGroupStyle = 'flex flex-col p-0 m-0 gap-tiny-small body-small-regular text-neutral-foreground-low';

  useEffect(() => {
    if (modal.visible) {
      sendViewEvent('information-use_modal', {}, { isAllowRetry: true });
    }
  }, [modal.visible, sendViewEvent]);

  return (
    <Drawer open={modal.visible}>
      <DrawerContent disableOutsideClick>
        <DrawerHeader className={'flex flex-col gap-normal-small'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_megaphone_md.svg`} className={'w-12 h-12'} alt="megaphone icon" />
          <p className="heading-small-bold m-0">이용 안내</p>
        </DrawerHeader>
        <DrawerBody>
          <div className={'flex flex-col gap-normal-large [&_p]:m-0 py-normal-medium mb-normal-small'}>
            <div className={groupSectionStyle}>
              <p className={textGroupTitleStyle}>이용 시 주의사항</p>
              <TextListGroup className={textGroupStyle}>
                <TextList>AI 답변은 참고용으로만 활용해주세요. AI 답변은 절대적인 지침이 아님을 기억해주세요.</TextList>
                <TextList>중요한 법률적 결정 전에는 반드시 당사 담당자와 상의하시기 바랍니다. 최종 판단과 결정은 전문가와 함께 해주세요.</TextList>
                <TextList>직원명, 주민번호, 급여액 등 구체적인 개인정보가 포함된 질문은 하지 말아 주세요.</TextList>
                <TextList>회사명이나 특정 기업 정보는 언급하지 말아 주세요. 기업 식별이 가능한 정보는 보안상 주의가 꼭 필요해요.</TextList>
                <TextList>복잡하고 전문적인 사안이나, 법령 변경 등 최신 정보는 당사 담당자 또는 PL을 통해 직접 상담해주세요.</TextList>
              </TextListGroup>
            </div>

            <div className={groupSectionStyle}>
              <p className={textGroupTitleStyle}>효과적인 질문방법</p>
              <TextListGroup className={textGroupStyle}>
                <TextList>구체적인 개인정보를 포함하지 않고, 일반적인 상황으로만 질문해주세요.</TextList>
                <TextList>예를 들어, "신입사원인데, 4대보험 가입절차를 알려줘"</TextList>
                <TextList>예를 들어, "입사 시기에 따른 연차휴가 계산방법을 알려줘"</TextList>
              </TextListGroup>
            </div>

            <div className={groupSectionStyle}>
              <p className={textGroupTitleStyle}>면책사항</p>
              <TextListGroup className={textGroupStyle}>
                <TextList>AI 답변을 참고한 판단 및 결정으로 인한 불이익이나 손해는 별도로 책임지지 않아요.</TextList>
                <TextList>정확한 업무처리를 위해서는 반드시 당사 담당자를 통한 최종 확인이 필요해요.</TextList>
              </TextListGroup>
            </div>
          </div>
        </DrawerBody>
        <DrawerFooter>
          <ModalStickyBottomWrapper>
            <BoxButton size={'large'} variant={'filled-primary'} onClick={() => modal.hide()} className="w-full">
              확인
            </BoxButton>
          </ModalStickyBottomWrapper>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});
